import { ColumnDefinition, HeadCellFilterType } from 'components/DataTable/DataTableTypes';
import palette from 'theme/palette';

export interface EditHistoryItem {
  id: string;
  editedByFullName: string;
  editedBy: string;
  editedAt: string;
  sectionsUpdated: string[];
  details: EditHistoryItemDetail[];
  profileTabs: string[];
}

//todo this will be expanded in the future to properly repesent the full object
export interface EditBrHistoryItem {
  brStatus: string;
  brUid: string;
  version: number;
}

export interface EditHistoryItemDetail {
  fieldName: string;
  section: string;
  oldValue: string | null;
  newValue: string | null;
  profileTab: string;
}

export const EditHistoryHeadcells = (
  uniqueProfileTabs: string[],
  uniqueSections: string[],
): ColumnDefinition<EditHistoryItem>[] => {
  return [
    {
      id: 'editedAt',
      label: 'Edited on',
      filter: HeadCellFilterType.SORT,
      width: '12%',
    },
    {
      id: 'editedByFullName',
      label: 'Edited by',
      filter: HeadCellFilterType.CHECKBOXFILTER,
      width: '12%',
      color: palette.grey.dark,
    },
    {
      id: 'profileTabs',
      label: 'Profile tab',
      filter: HeadCellFilterType.CHECKBOXFILTER,
      filterValues: uniqueProfileTabs,
      width: '12%',
      color: palette.grey.dark,
    },
    {
      id: 'sectionsUpdated',
      label: 'Section',
      filter: HeadCellFilterType.CHECKBOXFILTER,
      filterValues: uniqueSections,
      width: '12%',
      color: palette.grey.dark,
    },
    {
      id: 'details',
      label: 'Old value',
      filter: HeadCellFilterType.EMPTY,
      width: '22%',
      color: palette.grey.dark,
    },
    {
      id: 'details',
      label: 'New value',
      filter: HeadCellFilterType.EMPTY,
      width: '22%',
      color: palette.grey.dark,
    },
    {
      id: 'id',
      label: '',
      filter: HeadCellFilterType.EMPTY,
      width: '8%',
      color: palette.grey.dark,
    },
  ];
};
